
import React from 'react'
import ActionList from './actionlist'
import queryString from 'query-string'
import { asBool } from './form/input/utils'
import { computeThis } from './form/list/usecomputed'
import clonedeep from "lodash.clonedeep"

const solve = (obj = {}, path = [], i = 0) => {
  return obj && (path.length <= (i + 1) ? (path.length === i ? obj : obj[path[i]]) : solve(obj[path[i]], path, i + 1))
}

const solveStorage = (path, storage) => JSON.parse(storage.getItem(path))

const replacer = (container) => (match, ini, objname, path, fin) => {
  if (path) path = resolveExpression(JSON.stringify(path), container)

	let json;
	
	switch (objname) {
		case "session":
		case "storage":
			if (!path) break;
			const storage = objname === "sesion" ? window.sessionStorage : window.localStorage;
			json = solveStorage(path, storage)
			break;
		case "global":
		case "local":
		case "cookie":
			json = path ? solve(container[objname], path.split(".")) : container[objname]
			break;
		default:
			break;
	}
  

  json = json === undefined ? null : json
  //console.log("solving", match, "to", json, ini, fin)
  if (ini && fin) return JSON.stringify(json);
  else return String.prototype.concat(ini || '', JSON.stringify(json?.toString() || '').slice(1, -1), fin || '')
}

const defaultParser = jsonValue => JSON.parse(jsonValue)

export const resolveExpression = (exp, obj, parser = defaultParser) => {
  //console.log("resolving expression:", exp, obj)

  if (!exp) return exp;

  const regex = new RegExp(/(?:("{0,1})@(local|global|cookie|storage|session))(?:(?:\.((?:[\w\dáéíóúñ.]+|@[\w\dáéíóúñ.]+;[.]{0,1})+)*)|(?=[\s}\];"]|$))(?:[;]|("{0,1}))/gi);
  
  while (regex.test(exp)) {
    exp = exp.replace(regex, replacer(obj))
    break;
  }

	return parser(exp);
}

export const getObjectValue = (obj = {}, path = "", i = 0) => {
  if (typeof path === "string") path = (path ? path.split(".") : [])
  return solve(obj, path, i)
}

const objectAsign = (val, obj = {}, key = "default") => {
	if (!isValid(val)) 
		delete obj[key]
	else if (val instanceof Function)
		obj[key] = val(obj[key], obj, key)
	else if (obj instanceof Object)
		obj[key] = clonedeep(val)
	else 
		console.warn("wrong assignment of ", val, ' in property ', key, ' of ', typeof obj, ' ', obj)
	return obj[key]
}

export const updateObjectValue = (obj, path, val, overwrite = false, autocreate = true, i = 0) => {

  if (typeof path === "string") path = (path ? path.split(".") : [])
  else if (!(path instanceof Array)) {
    console.warn("Una acción intenta modificar un objeto sin ruta (path) especificada", path);
    return;
  }
	const keyIdx = path[i];
    
  if (path.length <= i + 1) { //si path === []: 
		const oldVal = (path.length === i ? obj : obj[keyIdx]);

    if (keyIdx === "push()") {
      if (obj instanceof Array) obj.push(objectAsign(val));
      else console.warn("Una acción intenta añadir(push) un valor en un objeto", path);
    }
    else if (oldVal instanceof Array || !(oldVal instanceof Object) || !(val instanceof Object) || (val instanceof Function) || overwrite) {
      objectAsign(val, obj, keyIdx)
    }
    else
      Object.entries(val).forEach(([key, value]) => objectAsign(value, oldVal, key))

    return;
  }

	if(!isValid(obj[keyIdx])) {
		if (!autocreate) return; //should not autocreate since object dont exists.
		obj[keyIdx] = ((isNaN(path[i + 1]) && path[i + 1] !== "push()") ? {} : [])
	}
  
  updateObjectValue(obj[keyIdx], path, val, overwrite, autocreate, i + 1)
}


export const getActionListOuterData = (action, data, neededData = {}) => {
  const newNeeded = {}
  let shouldUpdate = false;

  if (action)
    action.forEach((act) => {
      if (act.property)
        act.property.forEach((prop) => {
          if (prop.source === "abs") {
            newNeeded[prop.value] = newNeeded[prop.value] || getObjectValue(data, prop.value)
            if (neededData[prop.value] !== newNeeded[prop.value]) shouldUpdate = true;
          }
        });
    });

  return [newNeeded, shouldUpdate];
}


export const syncQueryString = ({ dispatch, meta, query, outerData }) => {
  if (!meta) return;

  let search = meta.location.search || "?";
  const searchObj = search && queryString.parse(search);
  const dataQuery = query;
  const dataObj = {};
  const current = meta.location.current;
  let data;

  if (dataQuery instanceof Object) { //query expected
    Object.entries(dataQuery).forEach(([key, detail]) => {
      dataObj[key] = outerData[detail];

      if (search !== current && dataObj[key] !== (searchObj && searchObj[key])) {

        // console.log('syncQueryString','updating data from search', detail, searchObj && searchObj[key], "search: ", search, "current:", current)
        dispatch({ type: "set-data", path: detail, payload: searchObj && searchObj[key] })
      }
    })

    data = "?" + queryString.stringify(dataObj, { skipEmptyString: true, skipNull: true });
    search = "?" + queryString.stringify(searchObj, { skipEmptyString: true, skipNull: true })

    if ((!current && search) || (current !== search)) {
      // console.log('syncQueryString',"setting current from search:", search)
      dispatch({ type: "set-data", path: "meta.location.current", payload: search });
    } else if (data !== current && current) {
      // console.log('syncQueryString', "pushing this", data, "from current: ", current)
      // console.log('syncQueryString', "with this args", search, query, outerData )
      meta.history.replace(`${meta.location.path}${data}`);
    }
  }
  //console.log("current location: ", `>${search}<`, "|" , current, "|", data);
}

//retorna una función que recibe (data, close) y que a su vez retorna una función que ejecutará las acciones concretas.
const triggerNoAction = () => async () => {}

export const getTriggerAction = ({ actionNames = [], meta, withData = {}, pageData = {} }) => {
  const actions = (actionNames instanceof Array) ? actionNames : actionNames.split(";").filter(e => e);

  return actions.length
    ? (data, close, processingFlagPath) => () => {
			const combinedFieldData = asArray(withData)
				.reduce( (obj, fieldDataExpression) => {
					
					const fieldData = typeof fieldDataExpression === "string" 
						? resolveExpression(fieldDataExpression, { local: data, global: pageData }) 
						: fieldDataExpression

					
					//console.log("triggering action with data as: ", typeof fieldDataExpression, "solved to: " , fieldData)
					
					return {
						...obj,
						...(fieldData instanceof Object ? fieldData : {})
					}

				}, {} )
			

			meta.run(actions, { ...combinedFieldData, ...data }, close, processingFlagPath)
		}
    : triggerNoAction
}

const getButtons = (buttonList = [], properties = {}) => {
  //console.log("rendering this buttonlist:", JSON.stringify(buttonList));

  const buttons = buttonList.map(button => {
    var withData = tryJSON(button.data) || {}
    if (!(withData instanceof Object)) {
      console.warn(`Intentó recibir data en ${button.label} pero recibió ${typeof (withData)}: ${withData}`);
      withData = {}
    }
    const flags = {};

    if (button.flags) (button.flags?.split(";") || []).forEach(flag => flags[flag] = true);

    return {
      ...button,
      ...flags,
      trigger: getTriggerAction({ actionNames: button.action, withData, ...properties })
    }
  })

  return parentProps => <ActionList buttons={buttons} {...parentProps} />
}

export const typeFromSample = sample => {
  let customtype;
  let decimal;

  if (isNaN(sample)) {
    const dateortimeregx = new RegExp(/^(\d{2,4}[-/]\d{2}[-/]\d{2}){0,1}[\sT]{0,1}((\d{1,2}:{0,1}){3}(\.\d{1,6}){0,1}){0,1}$/)
    if (dateortimeregx.test(sample)) {
      const datetimeregx = new RegExp(/^(\d{2,4}[-/]\d{2}[-/]\d{2})[\sT](\d{1,2}:{0,1}){3}(\.\d{1,6}){0,1}$/)
      const timeregx = new RegExp(/^([0-9]{1,2}:{0,1}){3}(\.\d{1,6}){0,1}$/)

      if (datetimeregx.test(sample)) customtype = "datetime-local";
      else if (timeregx.test(sample)) customtype = "time";
      else customtype = "date";
    } else customtype = "text";

  } else {
    const intregx = new RegExp(/^\d{1,20}$/)

    customtype = "number";
    decimal = intregx.test(sample) ? false : true;
  }

  return { type: customtype, decimal }
}

export const displayFormatter = ({ type, currency, percent, decimal }) => {
  switch (type) {
    case "number":
      //console.log('displayFormatter', currency, asBool(percent), asBool(decimal), name)
      const shouldAddDecimals = (decimal || currency) ? { minimumFractionDigits: 2, maximumFractionDigits: 2 } : { minimumFractionDigits: 0, maximumFractionDigits: 0 }
      const formatter = new Intl.NumberFormat('en-US', {
        style: (percent && "percent") || "decimal",
        ...shouldAddDecimals
      });

      return (dataCurrency) => {
        return {
          format: value => (isNaN(value) ? undefined : (formatter.format(value) + (currency && !percent ? (" " + (dataCurrency || currency)) : ""))),
          currency: dataCurrency || currency
        }
      }
    case "date":
      return () => ({ format: value => value && (new Date(Date.parse(value))).toLocaleDateString("es-DO", { timeZone: "UTC" }) })
    case "time":
      const _timeregx = new RegExp(/^([0-9]{1,2}:{0,1}){3}$/)

      return () => ({ format: value => value && (new Date(Date.parse(_timeregx.test(value) ? "2000/01/01 " + value : value))).toLocaleTimeString("es-DO") })
    case "datetime-local":
      return () => ({ format: value => value && (new Date(Date.parse(value))).toLocaleString("es-DO") })
    case "custom":
      return (_currency, _sample) => (displayFormatter({ ...typeFromSample(_sample), currency: _currency})(_currency))
    case "select":
      return undefined;
    default:
      return () => ({ format: value => value })
  }
}

const booleanfieldfields = ['notaggregable', 'notremovable', 'select_custom', 'select_multi', 'select_lookup', 'required', 'readonly', 'percent', 'decimal', 'computed', 'preview', 'hideonboard', 'hideonform', 'clearable', 'json', 'flexgrow', 'noheader', 'globalpath', 'nowait', 'waitblur', 'clearonly', 'accordion']

export const getEntityFromSample = (sample = {}) =>
  Object.entries(sample).map(([column, value]) => {
    const len = value.length || 15;
    const { type, decimal } = typeFromSample(value)
    return {
      name: column,
      title: column,
      path: column,
      type,
      decimal,
      size: len < 7 ? "xs" : (len < 16 ? "sm" : (len < 30 ? "md" : "lg")),
      formatter: displayFormatter({ type, decimal })
    }
  })


export const getEntity = (entityList = []) => {
  const entities = {}
  entityList.forEach(entity => {
    const fields = entity.field && clonedeep(entity.field)
    if (entity.name) entities[entity.name] = fields;
    if (entity.id) entities[entity.id] = fields;
  })

  //se completan las refrencias internas.
  entityList.forEach(entity => {
    if (entity.field) entity.field.forEach((field, idx) => {
      const newField = entities[entity.name || entity.id][idx]
      if (field.entity) newField.entity = entities[field.entity]; //se completan las refrencias internas.

      //boolean-fields
      booleanfieldfields.forEach(key => newField[key] = asBool(field[key]))

      if (field.flags) (field.flags?.split(";") || []).forEach(flag => newField[flag] = true);

      newField.formatter = displayFormatter(newField)
    })
  })
  return entities
}

export const asTextArray = (textArray, delimiter = ";") => typeof textArray === "string" ? textArray.split(delimiter) : (Array.isArray(textArray) ? textArray : undefined)

export const cleanText = (value = "") => {
	return (value === undefined || value === null || value instanceof Object)
		? ""
		: value
			.toString()
			.normalize("NFD")
			.replace(/[\u0300-\u036f]/g, "")
			.toLowerCase();
}

export const keydownEventFilter = (keydownSettings = [], properties) => {
	const settings = isValid(keydownSettings) ? asArray(keydownSettings) : []
	return (...triggerArgs) => {
		if (!settings.length) return null;

		/**
		 * @param {KeyboardEvent} e
		 */
		return _e => {
			const e = _e.detail;
			
			const setting = settings.find( setting => {
				/**
				 * @type {HTMLFormElement | HTMLInputElement}
				 */
				// const target = e.target;
				
				const result = 
					e.altKey === asBool(firstValid(setting.alt, setting.altkey, setting.altKey, false)) &&
					e.shiftKey === asBool(firstValid(setting.shift, setting.shiftkey, setting.shiftKey, false)) &&
					e.ctrlKey === asBool(firstValid(setting.ctrl, setting.ctrlkey, setting.ctrlKey, false)) &&
					e.metaKey === asBool(firstValid(setting.win, setting.winkey, setting.winKey, false)) &&
					asTextArray(setting.code).includes(e.code || e.key) &&
					( !firstValid(setting.targetId, setting.targetid) || cleanText(e.targetId) === cleanText(firstValid(setting.targetId, setting.targetid)) ) &&
					( !firstValid(setting.targetName, setting.targetname) || cleanText(e.targetName) === cleanText(firstValid(setting.targetName, setting.targetname)) )

				return result;
			})
			
			if (setting) {
				getTriggerAction({ 
				  ...properties, 
				  actionNames: setting.action, 
				  withData: { 
				    ...(setting.data || {}),
				    _keydown: {
				      targetId: e.targetId,
				      targetName: e.targetName,
				      isComposing: e.isComposing
				    }
				  }
				})(...triggerArgs)()
			}
			
		}
	}
}

export const getForm = (configForms, title, properties) => {
  return (configForms && configForms.length) ? configForms.map(form => ({
    title: form.title || (form.type === "header" && title) || undefined,
    type: form.type,
    name: form.name,
    entity: form.entity,
    dispatch: properties.dispatch,
    //pageData: properties.pageData,
		keydown: keydownEventFilter(form.keydown, properties),
		submit: getTriggerAction({ actionNames: form.submit, ...properties }), 
    close: getTriggerAction({ actionNames: form.close, ...properties }),
    hasCloseActions: !!form.close,
    buttons: getButtons(form.button, properties),
  })) : []
}

export const getReader = (configReaders, properties, pageData) => {
  return (configReaders && configReaders.length) ? configReaders.map(({ params, ...reader }) => ({
    ...reader,
    property: resolveExpression(params, { global: pageData, local: pageData }),
    dispatch: properties.dispatch,
    action: getTriggerAction({ actionNames: reader.action, ...properties })
    //data: properties.pageData,
  }
  )) : []
}

export const getBoard = (configBoards, entity, properties) => {
  return (configBoards && configBoards.length) ? configBoards.map((board) => ({
    ...board,
    hideifempty: asBool(board.hideifempty),
    entity: entity[board.entity],
    buttons: getButtons(board.button, properties),
    hasButtons: !!board.button,
    click: getTriggerAction({ actionNames: board.click, ...properties }),
    hasClickActions: !!board.click,
    dispatch: properties.dispatch,
    //data: properties.pageData,
  })) : []
}


export const tryJSON = val => {
  let result;
  try {
    result = (val === "undefined" ? undefined : JSON.parse(val))
  } catch (error) {
    result = val
  }
  return result;
}
export const isValid = (val) => (val !== undefined && val !== null)
export const firstValid = (...vals) => vals.find(isValid)
export const asArray = (val) => val instanceof Array ? val : [val]

export const getPropertyList = ({ innerdata, outerdata, properties }) => {
  const result = {}
  const props = (properties instanceof Array) ? properties : [properties];

  props.forEach((property) => {
    let val

    switch (property.source) {
      case "self":
        val = tryJSON(property.value)
        updateObjectValue(result, property.key, val)
        return;
      case "rel":
        val = isValid(property.value) ? getObjectValue(innerdata, property.value) : undefined
        break;
      case "abs":
        val = isValid(property.value) ? outerdata[property.value] : undefined
        break;
      default:
        console.warn("unknown property source", property)
        return;
    }

    if (val !== undefined) updateObjectValue(result, property.key, val)
  })

  return result;
}

export const ifNaN = (a, b) => isNaN(a) ? b : a;

export const isQuoted = text => typeof text === 'string' &&  (text.startsWith("'") || text.startsWith('"'))

export const getPropertyObject = (innerdata, outerdata, properties, cookies) => {
  const result = {}
  //console.log("solving properties", properties)
  const obj = {
    global: outerdata,
    local: innerdata,
    cookie: cookies,
  }
  Object.entries(properties).forEach(([key, val]) => {

    switch (key) {
      case "property": //ignore
      case "type": //ignore
        break;
      case "_stack":
      case "name":
      case "replace":
      case "inner":
      case "actions":
      case "exception":
			case "overwrite":
			case "thread":
        result[key] = val;
        break;
      case "method":
      case "page":
      case "board":
      case "form":
      case "as":
      case "path":
      case "label":
      case "delta":
        if (!isQuoted(val)) {
          result[key] = val;
          break
        }
			// eslint-disable-next-line no-fallthrough
      case "show":
      case "seconds":
      case "timeout":
      case "iteration":
      case "params":
      case "message":
      case "data":
      case "entity":
      case "info":
        result[key] = resolveExpression(val, obj)
        break;
      case "set":
        result[key] = val.map(({ cookie, storage, maxage, path, path_exp, exp, compute }) => ({
          cookie,
					storage,
          maxage: ifNaN(Number(maxage), null),
          path: path || (path_exp && resolveExpression(path_exp, obj)) || undefined,
          data: asBool(compute) ? computeThis(exp, obj) : resolveExpression(exp, obj, tryJSON)
        }))
        break;
      default:
        console.warn("solving action property by default: ", key)
        result[key] = resolveExpression(val, obj)
    }
  })
  //console.log("resulting", result)
  return result;
}

/* esto debe resolver el problema de la comilla doble escapada. (puediera ser remplazando comillas dobles por simple, pero eso hay que probarlo primero...)
const safeResolveExpression = (exp, obj) => tryJSON(resolveExpression(JSON.stringify(exp), obj))
*/
